export default {
  listTitle: 'Транзакции',
  empty: 'Транзакции не найдены',
  columns: {
    id: 'ID',
    amount: 'Сумма',
    fromAccountId: 'From',
    toAccountId: 'To',
    status: 'Статус',
    type: 'Тип',
    description: 'Описание',
    operationId: 'Operation ID',
    createdAt: 'Создан',
  },
  statuses: {
    pending: 'pending',
    processing: 'processing',
    success: 'success',
    completed: 'completed',
    failed: 'failed',
    canceled: 'canceled',
  },
  types: {
    transfer: 'transfer',
    deposit: 'deposit',
    withdraw: 'withdraw',
    topup: 'topup',
    freeze: 'freeze',
  },
  filters: {
    transactionIdPlaceholder: 'ID транзакции',
    fromAccountPlaceholder: 'From account',
    toAccountPlaceholder: 'To account',
    operationIdPlaceholder: 'Operation ID',
    statusAll: 'Все статусы',
    typeAll: 'Все типы',
    reset: 'Сбросить',
  },
  actions: {
    copyId: 'Скопировать ID',
    copyIdSuccess: 'ID скопирован',
    copyIdFailed: 'Не удалось скопировать ID',
    openFilteredList: 'Открыть список с фильтром',
  },
  errors: {
    loadList: 'Не удалось загрузить транзакции',
  },
}
